import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../../services/administrator/admin.service';
import { IDoaCategory } from '../../../../../interface/administrator/admin';
import { IDoaSubCategory } from '../../../../../interface/administrator/admin';
import { MaterialModule } from '../../../../../shared/module/material.module';
import { SharedServices } from '../../../../../shared/services/shared.services';

@Component({
  selector: 'app-add-update-dialog',
  imports: [CommonModule,MaterialModule,ReactiveFormsModule],
  templateUrl: './add-update-dialog.component.html',
  styleUrl: './add-update-dialog.component.css'
})
export class AddUpdateDialogComponent {
  DoaTypesForm: FormGroup;
  isDeveloper: boolean = false;
  isLoading: boolean = false;
  dataSource: IDoaCategory[] = [];
  dataSource1: IDoaSubCategory[] = [];
  selectedCategory: string = ''
  filteredTypes: IDoaSubCategory[] = [];
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateDialogComponent>,
    private http: HttpClient,
    private adminService: AdminService,
    private sharedService:SharedServices
  ) {
    this.DoaTypesForm = this.fb.group({
      id: [data.user?.id || null],
      typeCode: [ {value : data.user?.typeCode || '', disabled: data.isEdit},[Validators.required, Validators.maxLength(2)]],
      typeName: [data.user?.typeName || '', [Validators.required, Validators.maxLength(500)]],
      catCode: [data.user?.catCode || '', [Validators.required]],
      subCatCode: [data.user?.subCatCode || ''],
      noteCode: [data.user?.noteCode || '', Validators.maxLength(1)],
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.getDoaCategory();
    this.getDoaSubCategory();
      if (this.data.isEdit) {
        this.DoaTypesForm.patchValue(this.data.user);
        this.data.initialValues = this.DoaTypesForm.getRawValue();
        this.selectedCategory = this.data.user.catCode;
      }
  }
  getDoaCategory(): void {
    this.adminService.getDoaCategory()
      .subscribe((data: IDoaCategory[]) => {
        this.dataSource = data;
        if (this.dataSource.length > 0 && !this.data.isEdit) {
          this.selectedCategory = this.dataSource[0].catCode; // Set default category
          this.onCategoryChange();
        }
      }, error => {
        console.error('Error fetching categories', error);
      });

  }
  getDoaSubCategory(): void {
    this.adminService.getDoaSubCategory()
      .subscribe((data: IDoaSubCategory[]) => {
        this.dataSource1 = data;
        this.onCategoryChange();
      }, error => {
        console.error('Error fetching subcategories', error);
      });

  }
  onCategoryChange(): void {
    this.filteredTypes = this.dataSource1.filter(type => type.catCode === this.selectedCategory);
  }

  onSave(): void {
    this.isLoading = true;
    if (this.DoaTypesForm.invalid) {
      this.sharedService.openModal('Message', 'Please enter all required information');
      this.isLoading = false;
      return;
    }
  
    const typeCode = this.DoaTypesForm.get('typeCode')?.value;
    const doaTypeExists = this.data.existingDoaTypes.some((doaType: any) => doaType.typeCode === typeCode);
  
    if (!this.data.isEdit && doaTypeExists) {
      this.sharedService.openModal('Message', 'DOA type code already exists');
      this.isLoading = false;
    } else {
      if (this.data.isEdit) {
        const updatedDoaType = this.DoaTypesForm.getRawValue();
        if (JSON.stringify(this.data.initialValues) === JSON.stringify(updatedDoaType)) {
          this.sharedService.openModal('Message', 'No changes detected');
          this.isLoading = false;
          return;
        }
        this.adminService.updateDoaType(updatedDoaType).subscribe({
          next: response => {
            this.dialogRef.close(response);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Updated Successfully');
          },
          error: error => {
            console.error('Error updating DOA type', error);
            this.isLoading = false;
          }
        });
      } else {
        this.adminService.addDoaType(this.DoaTypesForm.value).subscribe({
          next: response => {
            this.dialogRef.close(true);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Added Successfully');
          },
          error: error => {
            console.error('Error adding DOA type', error);
            this.isLoading = false;
          }
        });
      }
    }
  }
}